import { Roarr } from 'roarr';
export const Logger = Roarr.child({
    package: '@contra/sentry',
});
//# sourceMappingURL=Logger.js.map